import { useState, useCallback } from 'react';

/**
 * Hook to manage animated splash screen visibility.
 * Currently disabled - native platforms use the Capacitor native splash screen,
 * which is configured in capacitor.config.ts for a seamless single-splash experience.
 * Web users skip directly to app.
 */
export const useSplashScreen = () => {
  // Disabled: Native uses Capacitor splash screen only (no double splash)
  // Web: No splash needed
  const [showSplash, setShowSplash] = useState(false);

  const hideSplash = useCallback(() => {
    setShowSplash(false);
  }, []);

  return {
    showSplash,
    hideSplash,
  };
};
